module.exports = __webpack_public_path__ + "img/logon-right.0a091d13.png";